import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => {
    const useStorage: any = localStorage.getItem('__user')
    const user = JSON.parse(useStorage)
    return user
  },

  actions: {
    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },

    changeUserName(userName: string) {
      this.userName = userName
    },
  },
})
